import React, { Component } from 'react';
import { connect } from 'react-redux';
import WebsiteSelector from '../Components/WebsiteSelector';
import { load } from '../Actions/WebsiteSelector.action';

class WebsiteSelectorContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.load();
    }

    render() {
        // Render the component
        return <WebsiteSelector {...this.props} />
    }
}

const mapStateToProps = (state) => {
    //console.log(state.websiteSelector)
    return {
        websites: state.websiteSelector.websites,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        load: () => dispatch(load()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteSelectorContainer);